import { Delete, Get, Post, Put } from "./index";

export const getAllTodo = async () => {
  return Get({ url: `v1/dashboard/getall-todo` });
};
export const getDashBoardEventDetails = async () => {
  return Get({ url: `v1/dashboard` });
};
export const getReminders = async () => {
  return Get({ url: `v1/dashboard/reminders` });
};
export const getRecentEnquiries = async (data: any) => {
  return Post({ url: `v1/dashboard/getRecentEnquiries`, payload: data });
};
export const getBookedEvents = async (data: any) => {
  return Post({ url: `v1/dashboard/getBookedEvents`, payload: data });
};
export const createtodos = async (data: any) => {
  return Post({ url: `v1/dashboard/create-todo`, payload: data });
};

export const updatetodo = async (id: string, data: any) => {
  return Put({
    url: `v1/dashboard/update-todo/${id}`,
    payload: data,
  });
};

export const deletetodo = async (id: number | string) => {
  return Delete({ url: `v1/dashboard/delete/${id}` });
};

//API FOR EVENTS BOOKED ON RESPECTIVE DATE
export const getEventBookedOnSelecteddate=async(payload: any)=>{
  // console.log(payload,'payload')
  return Post({url:`v1/event/getEventByDate`,payload})
}

export const readNotification = async (id: string, data: any) => {
  return Put({
    url: `v1/notification/update/${id}`,
    payload: data,
  });
};

export const addEventReminderDetails = async (payload: any) => {
  return Post({ url: `v1/event/addEventReminderDetails`, payload });
};


